<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
          label="类型"
        >
          <el-input
            v-model="searchForm.advTitle"
            placeholder="类型"
            style="width: 100px;"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
            type="primary"
            size="mini"
            icon="el-icon-circle-plus"
            @click="add"
    >
      新增
    </el-button>
    <el-button
      v-if="multipleSelection.length>0"
      type="danger"
      size="mini"
      icon="el-icon-delete"
      @click="batchDel"
    >
      删除
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="编号"
      >
        <template slot-scope="scope">
          {{scope.row.id}}
        </template>
      </el-table-column>

      <el-table-column
              label="标题"
      >
        <template slot-scope="scope">
          {{scope.row.title}}
        </template>
      </el-table-column>
      <el-table-column
              label="会员特权"
      >
        <template slot-scope="scope">
          {{scope.row.title_details}}
        </template>
      </el-table-column>

      <el-table-column
        label="类型"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.card_type}}
        </template>
      </el-table-column>
      <el-table-column
        label="会员"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.type=='0'">
            商铺会员
          </div>
          <div v-else-if="scope.row.type=='1'">
            平台会员
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="平台/商铺"
      >
        <template slot-scope="scope">
          {{scope.row.agentname}}
        </template>
      </el-table-column>
      <el-table-column
              label="原价格(元)"
      >
        <template slot-scope="scope">
          {{scope.row.oldprice}}
        </template>
      </el-table-column>
      <el-table-column
              label="价格(元)"
      >
        <template slot-scope="scope">
          {{scope.row.price}}
        </template>
      </el-table-column>
      <el-table-column
              label="积分"
      >
        <template slot-scope="scope">
          {{scope.row.notice}}
        </template>
      </el-table-column>
      <el-table-column
              label="数量"
      >
        <template slot-scope="scope">
          {{scope.row.unit}}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain size="mini"    @click="del(scope.row)">删除</el-button>
          <el-button type="primary" plain  size="mini"    @click="openEditForm(scope.row)">修改</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
            :agent="agent"
            v-model="editFormVisible"
            @submit="getTableData"
    />
  </d2-container>
</template>
<script>
import * as memberService from '@/api/sys/member'
import util from '@/libs/util.js'
import editForm from './editForm'
export default {
  name: 'MembergglPage',
  components: { editForm },
  data () {
    return {
      searchForm: {
        advTitle: ''
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
      dateRange: [],
      pickerOptions: {},
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: '',
        order: ''
      },
      agent: {},
      editFormVisible: false
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {

    getTableData () {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        dl_type: util.cookies.get('dl_type'),
        agentid: util.cookies.get('agentid'),
        xt_id: util.cookies.get('xt_id'),
        descending: this.sort.order === 'descending',
        filter: this.searchForm
      }
      memberService.listMemberCard(query).then(data => {
        this.tableData = data.rows
        this.page.total = data.totalCount
      })
    },
    handleSearchFormSubmit () {
      this.getTableData()
    },
    handleSearchFormReset () {
      this.$refs.searchForm.resetFields()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleSortChange (val) {
      this.sort.prop = val.prop
      this.sort.order = val.order
      this.getTableData()
    },
    handleSizeChange (val) {
      this.page.size = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.current = val
      this.getTableData()
    },
    add () {
      this.agent = {}
      this.editFormVisible = true
    },
    openEditForm (oneclass) {
      this.agent = oneclass
      this.editFormVisible = true
    },
    batchDel () {
      this.$confirm('确认删除？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        memberService
          .delMemberpriceBath({
            ids: this.multipleSelection.map(item => item.id).join()
          })
          .then(() => {
            this.getTableData()
          })
      })
    },
    del (oneclass) {
      this.$confirm('确认删除？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        memberService.delMemberprice({ id: oneclass.id }).then(() => {
          this.getTableData()
        })
      })
    }
  }
}
</script>
